// extracted by mini-css-extract-plugin
export var addButton = "_pk-0";
export var border = "_pk-8";
export var check = "_pk-h";
export var danger = "_pk-6";
export var dropdownContainer = "_pk-1";
export var editModalBody = "_pk-j";
export var footerContainer = "_pk-i";
export var fullWidth = "_pk-a";
export var hide = "_pk-9";
export var icon = "_pk-3";
export var input = "_pk-7";
export var inputFlex = "_pk-b";
export var inputWrapper = "_pk-c";
export var manualFocus = "_pk-5";
export var optionButton = "_pk-4";
export var pillWrapper = "_pk-e";
export var pointer = "_pk-2";
export var showOverflow = "_pk-f";
export var tagsFlex = "_pk-d";
export var xButton = "_pk-g";